export default "__VITE_ASSET__BtOFavme__"